<template>
  <div
    class="upload-area"
    :class="{ dragging: isDragging }"
    @dragover.prevent="isDragging = true"
    @dragenter.prevent="isDragging = true"
    @dragleave.prevent="isDragging = false"
    @drop.prevent="handleDrop"
    @click="openFileDialog"
  >
    <p v-if="!previewImage" style="font-size: 12px;">{{ $t('click_or_drag_a_file') }}</p>
    <img v-if="previewImage" :src="previewImage" alt="미리보기" class="preview-image" />
    <input
      type="file"
      ref="fileInput"
      @change="handleFileChange"
      accept="image/*"
      hidden
    />
  </div>
</template>


<script setup>
import { previewImage, previewImageFile } from "@/utils/ImageUtility";
import { ref } from "vue";

const fileInput = ref(null);
const isDragging = ref(false);

// 파일 선택 창 열기
const openFileDialog = () => {
  fileInput.value?.click();
};

// 파일 변경 시 처리
const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file && file.type.startsWith("image/")) {
    previewImage.value = URL.createObjectURL(file);
    previewImageFile.value = file;
  }
  // ✅ 같은 파일도 다시 선택할 수 있도록 강제로 초기화
  fileInput.value.value = "";
};

// 드래그앤드롭 처리
const handleDrop = (event) => {
  isDragging.value = false;
  const file = event.dataTransfer.files[0];
  if (file && file.type.startsWith("image/")) {
    previewImage.value = URL.createObjectURL(file);
    previewImageFile.value = file;
  }
};
</script>

<style>
.upload-area {
  width: 100%;
  height: 100%;
  border: 2px dashed #ccc;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  text-align: center;
}

/* ✅ 드래그 중일 때 적용될 스타일 */
.upload-area.dragging {
  border-color: #007bff;
  background-color: #e6f7ff;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  border-radius: 5px;
}
</style>